import Auth from '../../modules/Authentication'
import { handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables/index'

const headers = {}

export default class PayrollClaims {
  auth = new Auth()
  list = ({ owner, company, status }) => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}payrollClaims?select=${select}` +
        (owner ? `&owner=${owner || ''}` : '') +
        (status ? `&status=${status || ''}` : '') +
        (company ? `&company=${company || ''}` : ''),
      {
        headers: headers,
        method: 'GET',
      }
    )
      .then(handleErrors)
      .then(handleResponse)
  }
}
